export default "https://assets-v2.scaler.com/packs/images/half-star.5b840c.svg";